export default __webpack_public_path__ + "static/media/work_ec-userinfos.fb5de531.jpg";